import { IntegrationSystem } from "../../types";
import { OmniletterConnectView } from "./ConnectView";
import { OmniletterSettingsView } from "./SettingsView";

export const OmniletterSystem: IntegrationSystem = {
  ConnectView: OmniletterConnectView,
  SettingsView: OmniletterSettingsView
};
